var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltip != null)?_c('v-tooltip',{attrs:{"right":"","max-width":"25%","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"mb-1",attrs:{"size":"large","color":"grey","dark":""}},on),[_vm._v("mdi-information")])]}}],null,false,1414088330)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltip)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }